<script>
    import { pop } from "svelte-spa-router";
    import { loading, business, showPopup } from "../stores.js";
    import * as BusinessDAL from "../dal/business-dal";
    import AutoComplete from "simple-svelte-autocomplete";
    import { onMount } from "svelte";
    import { loadLocalFile } from "../file-service.js";

    let settings = {
        enabled: false,
        cities: [],
        addedPrice: false,
        price: 0,
    };

    let cities;

    let cityToAdd;

    onMount(async () => {
        loadCities();
    });

    //load cities
    async function loadCities() {
        const url = "csv/cities.json";
        const response = window.cordova
            ? await loadLocalFile(url)
            : await fetch(url);

        const data = window.cordova ? response : await response.json();
        cities = [];

        for (let cityCode in data) {
            cities.push({
                id: cityCode,
                name: data[cityCode],
            });
        }
        // console.log(cities)
    }

    async function save() {
        showPopup("האם אתה בטוח?", async () => {
            try {
                $loading = true;
                await BusinessDAL.setDeliverySettings($business.code, settings);
                $loading = false;
                pop();
            } catch (e) {
                $loading = false;
                UserDAL.sendLog("setOutOfStock", e.toString());
                showPopup("משהו השתבש", () => {});
            }
        });
    }

    function addCity() {
        if (cityToAdd) {
            if (settings.cities.filter((x) => x.id == cityToAdd.id).length > 0)
                return;

            settings.cities.push(cityToAdd);
            cityToAdd = null;
            settings = settings;
        }
    }

    function removeCity(idx) {
        settings.cities.splice(idx, 1);
        settings = settings;
    }

    business.subscribe((b) => {
        if (b.deliverySettings) {
            settings = b.deliverySettings;
        }
    });

</script>

<div class="overlay" on:click={pop}>
    <div class="container">
        <div class="bg" on:click|stopPropagation>
            <div class="title">הגדרות משלוחים</div>
            <div class="active section">
                <label><input
                        type="checkbox"
                        bind:checked={settings.enabled}
                    />משלוחים פעילים
                </label>
            </div>
            <div class="list section" class:disabled={!settings.enabled}>
                <div class="sectionTitle">רשימת ישובים זמינים למשלוח</div>
                <div class="cities">
                    {#each settings.cities as city, idx}
                        <div class="city">
                            <button
                                class="removeCityBtn"
                                on:click={() => {
                                    removeCity(idx);
                                }}
                            >-</button>
                            {city.name}
                        </div>
                    {/each}
                </div>
            </div>
            <div class="section addCity" class:disabled={!settings.enabled}>
                <div class="sectionTitle">הוספת ישוב:</div>
                {#if cities}
                    <div class="addCityInputs">
                        <AutoComplete
                            className="selectCity"
                            hideArrow="true"
                            items={cities}
                            bind:selectedItem={cityToAdd}
                            labelFieldName="name"
                            maxItemsToShowInList="10"
                            placeholder="עיר"
                            itemFilterFunction={(item, query) => {
                                query = query.join(' ');
                                return item.name.startsWith(query);
                            }}
                        />
                        <button
                            class="addCityBtn"
                            on:click={addCity}
                        >הוספה</button>
                    </div>
                {/if}
            </div>
            <div class="price section">
                <input type="checkbox" bind:checked={settings.addedPrice} />
                תוספת תשלום למשלוח
                <div class:disabled={!settings.addedPrice}>
                    <input type="number" bind:value={settings.price} />
                    <span class="currency">₪</span>
                </div>
            </div>
            <div class="btns">
                <div class="save" on:click={save}>שמירה</div>
            </div>
        </div>
    </div>
</div>

<style>
    .price {
        display: flex;
        align-items: center;
    }

    .currency {
        font-size: 22px;
        margin-right: 10px;
    }
    input[type="checkbox"] {
        margin: 0;
        margin-left: 10px;
    }

    input[type="number"] {
        margin: 0;
        margin-right: 10px;
        width: 50px;
        border-radius: 4px;
    }
    .city {
        display: flex;
        margin-bottom: 10px;
        align-items: center;
    }

    .cities {
        padding-right: 10px;
    }
    .removeCityBtn {
        width: 20px;
        height: 20px;
        background: var(--red1);
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: white;
        border-radius: 100px;
        margin-left: 10px;
        margin-bottom: 0;
        font-size: 14px;
        line-height: 14px;
        border: none;
    }

    .addCityBtn {
        max-height: 2.25em;
        padding: 5px 11px;
        border-radius: 4px;
    }

    .overlay {
        position: fixed;
        background: #0004;
        width: 100%;
        height: 100%;
        padding: 10px;
        box-sizing: border-box;
        z-index: 2;
        display: block;
        justify-content: center;
        padding-top: var(--nav-bar-height);
        margin-bottom: 30px;
        top: 0;
        overflow: auto;
    }

    .container {
        margin-top: 30px;
        margin-bottom: 30px;
        margin: 14px;
        font-size: 16px;
    }

    .bg {
        width: 100%;
        max-width: 560px;
        background: white;
        direction: rtl;
        padding: 18px;
        border-radius: 3px;
        box-shadow: 0 20px 25px -20px;
        box-sizing: border-box;
        margin-left: auto;
        margin-right: auto;
    }

    .title {
        font-size: 20px;
        margin: 20px;
    }

    .section {
        margin: 20px;
    }

    .sectionTitle {
        font-size: 18px;
        margin-bottom: 10px;
    }

    .save {
        width: 100%;
        background: var(--green1);
        color: white;
        max-width: 300px;
        margin-left: auto;
        margin-right: auto;
        text-align: center;
        font-size: 20px;
        padding: 10px;
        margin-top: 40px;
        border-radius: 3px;
        cursor: pointer;
    }

    .disabled {
        opacity: 0.3;
        pointer-events: none;
    }
    @media screen and (max-width: 560px) {
        .overlay {
            padding: 0;
            padding-top: 30px;
        }
    }

</style>
